import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PdfLinkModule } from '@app/shared/pdf-link/pdf-link.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { TabsetModule } from '@app/shared/ux/tabs/tabset.module';
import { WucListModule, WucRackModule, WucTabsetItemModule, WucTabsetModule } from '@inshared/website-ui-components';
import { MopedBaseCoverageInfoComponent } from './moped-base-coverage-info.component';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@NgModule({
    declarations: [ MopedBaseCoverageInfoComponent ],
    exports: [
        MopedBaseCoverageInfoComponent,
    ],
    imports: [
        CommonModule,
        ListModule,
        PdfLinkModule,
        TabsetModule,
        WucListModule,
        WucRackModule,
        WucTabsetItemModule,
        WucTabsetModule,
    ],
})
export class MopedCoverageInfoModule { }
